import service from "@irati/utils/tracking/index";
var tracking = {
    clickWalletBalance: function (balance, currency) {
        var data = {
            balance: balance,
            currency: currency
        };
        service.trackWalletEvent("platform_click_wallet_balance", data);
    },
    viewWallets: function () {
        service.trackWalletEvent("view_wallets");
    },
    viewHome: function () {
        service.trackWalletEvent("perksgo_view_wallet");
    },
    clickBrowsePerks: function () {
        service.trackWalletEvent("perksgo_click_browse_perks");
    },
    clickLinkCard: function () {
        service.trackWalletEvent("perksgo_click_home_link_card");
    },
    clickFaqs: function () {
        service.trackWalletEvent("perksgo_click_faqs");
    }
};
export default tracking;
